export const LOGIN = 'user/authenticate';
export const AGENCE = 'liv/agence';
export const MAGASIN = '/magasin';
export const EMPLOYE = '/employe';
export const EQUIPE = '/equipe';
export const VEHICULE = '/vehicule';
export const IMPORTER = '/importer';